
import Vue from "vue";
import AppTab from "@/components/layout-editor/Tab.vue";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import AppPageSettings from "./PageSettings.vue";
import AppTextBlockListSettings from "./TextBlockListSettings.vue";
import AppBarcodeListSettings from "./BarcodeListSettings.vue";
import AppQrCodeListSettings from "./QrCodeListSettings.vue";
import AppImageListSettings from "./ImageListSettings.vue";
import AppZpl from "./Zpl.vue";
import AppEpson from "./Epson.vue";

export default Vue.extend({
	props: {
		tab: String,
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	components: {
		AppTab,
		AppPageSettings,
		AppTextBlockListSettings,
		AppBarcodeListSettings,
		AppQrCodeListSettings,
		AppImageListSettings,
		AppZpl,
		AppEpson
	}
});
